import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '@/data/content';
import * as Icons from 'lucide-react';
import { Seo } from '@/components/site/Seo';
import FinalCTA from '@/components/site/FinalCTA';

export default function Blog() {
  return (
    <div data-testid="page-blog">
      <Seo
        title="Home Repair & Improvement Articles | HearthOak Construction"
        description="Plain-language articles on drywall, painting, doors, trim and small home repairs — written from real project experience in Fort Worth & DFW."
        path="/blog"
      />
      <section className="border-b border-brand-border bg-brand-bone">
        <div className="container-x py-14 lg:py-20">
          <div className="max-w-3xl">
            <div className="eyebrow mb-3">Helpful Articles</div>
            <h1 className="h1">Plain-language reading on doors, paint, drywall, and small home projects.</h1>
            <p className="body-lg mt-6">
              These aren't marketing pieces. They are notes from real projects — what to know, what to ask, and what usually goes wrong when it does.
            </p>
          </div>
        </div>
      </section>

      <section className="surface-paper border-b border-brand-border">
        <div className="container-x py-16 lg:py-24">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {BLOG_POSTS.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                className="group p-8 lg:p-10 border border-brand-border bg-brand-bone hover:bg-brand-boneAlt transition-colors flex flex-col"
                data-testid={`blog-card-${p.slug}`}
              >
                <div className="flex items-center gap-3 font-sans text-xs uppercase tracking-[0.22em] text-brand-muted">
                  <span>{p.date}</span>
                  <span>·</span>
                  <span>{p.read} read</span>
                </div>
                <h2 className="mt-4 font-serif text-2xl lg:text-3xl text-brand-charcoal leading-tight">{p.title}</h2>
                <p className="mt-4 font-sans text-sm text-brand-muted leading-relaxed">{p.excerpt}</p>
                <div className="mt-6 pt-6 border-t border-brand-border flex items-center gap-2 font-sans text-xs uppercase tracking-[0.22em] text-brand-maroon">
                  Read article <Icons.ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
